// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.training-result-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem 0 2rem;
  background: var(--page-bg);
  min-height: auto;
  box-sizing: border-box;
}

.training-result-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
}
.training-result-header__back {
  background: none;
  border: none;
  padding: 0;
  font-size: 0.9rem;
  color: var(--muted-foreground);
  cursor: pointer;
  transition: color 0.2s ease;
}
.training-result-header__back:hover {
  color: var(--primary);
}
.training-result-header__back:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}
.training-result-header__sep {
  color: var(--muted-foreground);
  font-weight: 300;
}
.training-result-header__title {
  font-weight: 600;
  font-size: 1.15rem;
  color: var(--foreground);
  letter-spacing: -0.01em;
}
.training-result-header__version {
  font-size: 0.9rem;
  color: var(--muted-foreground);
}
.training-result-header__badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.25rem 0.6rem;
  border-radius: 4px;
  letter-spacing: 0.5px;
}
.training-result-header__badge--type {
  background: var(--info-soft);
  color: var(--info);
}
.training-result-header__badge--status {
  background: var(--primary-soft);
  color: var(--success);
}
.training-result-header__badge--success {
  background: var(--primary-soft);
  color: var(--success);
}
.training-result-header__badge--info {
  background: var(--info-soft);
  color: var(--info);
}
.training-result-header__badge--danger {
  background: var(--destructive-soft);
  color: var(--destructive);
}
.training-result-header__badge--default {
  background: var(--secondary);
  color: var(--secondary-foreground);
}
.training-result-header__actions {
  margin-left: auto;
  display: flex;
  gap: 0.5rem;
}

.overview-strip {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  margin-bottom: 1.25rem;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.overview-strip:hover {
  background: var(--card-hover);
  box-shadow: var(--shadow-md);
}
.overview-strip__grid {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
}
@media (max-width: 991px) {
  .overview-strip__grid {
    grid-template-columns: 1fr;
  }
}
.overview-strip__info {
  padding: 1.5rem;
  border-right: 1px solid var(--border);
}
@media (max-width: 991px) {
  .overview-strip__info {
    border-right: none;
    border-bottom: 1px solid var(--border);
  }
}
.overview-strip__metrics {
  padding: 1.5rem;
  background: linear-gradient(135deg, var(--page-bg-subtle) 0%, var(--muted) 100%);
}
.overview-strip__section-title {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 1px;
  color: var(--muted-foreground);
  text-transform: uppercase;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.overview-strip__section-title::before {
  content: "";
  width: 3px;
  height: 1rem;
  background: var(--primary);
  border-radius: 2px;
}
.overview-strip__info-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.75rem;
}
.overview-strip__info-item {
  min-width: 120px;
}
.overview-strip__info-label {
  display: block;
  font-size: 0.75rem;
  color: var(--muted-foreground);
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.overview-strip__info-value {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--foreground);
}
.overview-strip__metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
}
@media (max-width: 991px) {
  .overview-strip__metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .overview-strip__metrics-grid {
    grid-template-columns: 1fr;
  }
}

.metric-card {
  background: var(--card);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.metric-card:hover {
  background: var(--card-hover);
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}
.metric-card__header {
  display: flex;
  align-items: center;
  padding: 0.6rem 0.85rem;
}
.metric-card__icon {
  font-size: 0.85rem;
  margin-right: 0.5rem;
}
.metric-card__label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--muted-foreground);
  text-transform: uppercase;
}
.metric-card__body {
  padding: 0.85rem;
}
.metric-card__value {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--foreground);
  letter-spacing: -0.03em;
  line-height: 1.2;
}
.metric-card__progress {
  height: 4px;
  background: var(--muted);
  border-radius: 2px;
  margin-top: 0.6rem;
  overflow: hidden;
}
.metric-card__progress-bar {
  height: 100%;
  border-radius: 2px;
  transition: width 0.4s ease;
}

.training-charts {
  margin-bottom: 1.25rem;
}
.training-charts__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  align-items: stretch;
}
@media (max-width: 767px) {
  .training-charts__grid {
    grid-template-columns: 1fr;
  }
}

.training-chart-card {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s ease;
}
.training-chart-card:hover {
  background: var(--card-hover);
  box-shadow: var(--shadow-md);
}
.training-chart-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1.1rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--foreground);
  border-bottom: 1px solid var(--border);
  padding-left: 1.25rem;
  position: relative;
}
.training-chart-card__header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 1.25rem;
  background: var(--primary);
  border-radius: 2px;
}
.training-chart-card__loading {
  font-size: 0.85rem;
  color: var(--muted-foreground);
  font-weight: 400;
}
.training-chart-card__body {
  padding: 0.75rem 1rem;
  height: 300px;
  min-height: 300px;
}
.training-chart-card__empty {
  text-align: center;
  color: var(--muted-foreground);
  padding: 2rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.inference-playground {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  margin-bottom: 1.25rem;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.inference-playground:hover {
  background: var(--card-hover);
  box-shadow: var(--shadow-md);
}
.inference-playground__header {
  padding: 0.9rem 1.1rem 0.9rem 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--foreground);
  border-bottom: 1px solid var(--border);
  position: relative;
}
.inference-playground__header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 1.25rem;
  background: var(--primary);
  border-radius: 2px;
}
.inference-playground__body {
  padding: 1.25rem;
}
.inference-playground__grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr 0.85fr;
  gap: 1.25rem;
  align-items: stretch;
}
@media (max-width: 991px) {
  .inference-playground__grid {
    grid-template-columns: 1fr;
  }
}
.inference-playground__upload-zone {
  min-height: 200px;
  border: 2px dashed var(--border);
  border-radius: var(--radius-sm);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--muted-foreground);
  transition: border-color 0.2s ease, background 0.2s ease;
}
.inference-playground__upload-zone:hover {
  border-color: var(--primary);
  background: var(--primary-soft);
  color: var(--primary);
}
.inference-playground__upload-zone:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}
.inference-playground__upload-text {
  font-size: 1rem;
  font-weight: 500;
}
.inference-playground__upload-hint {
  font-size: 0.85rem;
  margin-top: 0.35rem;
  color: var(--muted-foreground);
}
.inference-playground__slider {
  margin-top: 1rem;
}
.inference-playground__slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.35rem;
  font-size: 0.9rem;
  color: var(--muted-foreground);
}
.inference-playground__preview {
  min-height: 220px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: var(--muted);
}
.inference-playground__preview img {
  max-height: 300px;
  width: 100%;
  object-fit: contain;
}
.inference-playground__preview-placeholder {
  text-align: center;
  padding: 1.5rem;
  font-size: 0.95rem;
  color: var(--muted-foreground);
}
.inference-playground__preview-placeholder span {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: var(--muted-foreground);
}
.inference-playground__classes {
  min-height: 220px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0.9rem;
  background: var(--muted);
}
.inference-playground__classes-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--muted-foreground);
  margin-bottom: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.inference-playground__classes-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.9rem;
}
.inference-playground__classes-list li {
  margin-bottom: 0.6rem;
}
.inference-playground__class--dimmed {
  opacity: 0.45;
}
.inference-playground__classes-empty {
  font-size: 0.9rem;
  color: var(--muted-foreground);
  line-height: 1.5;
}

.export-section {
  margin-bottom: 1.25rem;
}
.export-section__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  align-items: stretch;
}
@media (max-width: 767px) {
  .export-section__grid {
    grid-template-columns: 1fr;
  }
}
.export-section__card {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.export-section__card:hover {
  background: var(--card-hover);
  box-shadow: var(--shadow-md);
}
.export-section__card-header {
  padding: 0.9rem 1.1rem 0.9rem 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--foreground);
  border-bottom: 1px solid var(--border);
  position: relative;
}
.export-section__card-header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 1.25rem;
  background: var(--primary);
  border-radius: 2px;
}
.export-section__card-body {
  padding: 1.25rem;
}
.export-section__wide {
  margin-top: 1.25rem;
}
.export-section__label {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--muted-foreground);
  margin-bottom: 0.5rem;
}
.export-section__code {
  display: block;
  padding: 0.65rem 0.85rem;
  background: var(--muted);
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  word-break: break-all;
  margin-bottom: 1rem;
  border: 1px solid var(--border);
  font-family: var(--font-mono);
}
.export-section__pre {
  background: var(--page-bg-subtle);
  color: var(--foreground);
  padding: 1rem;
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  margin: 0;
  overflow-x: auto;
  font-family: var(--font-mono);
  line-height: 1.5;
}
.export-section__hint {
  font-size: 0.85rem;
  color: var(--muted-foreground);
  margin-top: 0.5rem;
}

.training-metadata {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  margin-bottom: 1.5rem;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.training-metadata:hover {
  background: var(--card-hover);
  box-shadow: var(--shadow-md);
}
.training-metadata__header {
  padding: 0.9rem 1.1rem 0.9rem 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--foreground);
  border-bottom: 1px solid var(--border);
  position: relative;
}
.training-metadata__header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 1.25rem;
  background: var(--primary);
  border-radius: 2px;
}
.training-metadata__body {
  padding: 1.25rem;
}
.training-metadata__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}
@media (max-width: 767px) {
  .training-metadata__grid {
    grid-template-columns: 1fr;
  }
}
.training-metadata__dl {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.35rem 1.25rem;
  margin: 0;
  font-size: 0.95rem;
}
.training-metadata__dl dt {
  color: var(--muted-foreground);
  font-weight: 500;
  font-size: 0.9rem;
}
.training-metadata__dl dd {
  font-weight: 500;
  margin: 0;
  color: var(--foreground);
}
.training-metadata__logs {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0.9rem;
  max-height: 200px;
  overflow-y: auto;
  font-size: 0.9rem;
  background: var(--muted);
  font-family: var(--font-mono);
}

.deploypack__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.deploypack__note {
  font-size: 0.85rem;
  color: var(--muted-foreground);
  line-height: 1.5;
  margin-bottom: 1rem;
}
.deploypack__alert {
  padding: 0.65rem 0.85rem;
  margin-bottom: 1rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--destructive);
  background: var(--destructive-soft);
  color: var(--foreground);
  font-size: 0.85rem;
  word-break: break-word;
}
.deploypack__facts {
  display: grid;
  grid-template-columns: minmax(6.5rem, auto) 1fr;
  gap: 0.4rem 0.9rem;
  margin: 0 0 1rem;
  font-size: 0.85rem;
}
.deploypack__facts dt {
  color: var(--muted-foreground);
  font-weight: 500;
}
.deploypack__facts dd {
  margin: 0;
  color: var(--foreground);
  min-width: 0;
}
.deploypack__token {
  display: block;
  -webkit-user-select: all;
          user-select: all;
  padding: 0.35rem 0.5rem;
  border-radius: var(--radius-sm);
  background: var(--muted);
  border: 1px solid var(--border);
  font-family: var(--font-mono);
  font-size: 0.78rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.deploypack__classes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}
.deploypack__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.deploypack__hint {
  margin-top: 0.75rem;
}

.exptargets {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}
.exptargets__head {
  padding: 0.9rem 1.25rem;
  border-bottom: 1px solid var(--border);
}
.exptargets__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--foreground);
}
.exptargets__sub {
  margin: 0.2rem 0 0;
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--muted-foreground);
}
.exptargets__list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.exptargets__empty {
  margin: 1.25rem;
  padding: 1rem 1.1rem;
  background: var(--page-bg-subtle);
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  line-height: 1.55;
  color: var(--muted-foreground);
}
.exptargets__empty p {
  margin: 0 0 0.35rem;
}
.exptargets__empty p:last-child {
  margin-bottom: 0;
}
.exptargets__empty-title {
  font-weight: 600;
  color: var(--foreground);
}
.exptargets__empty-note {
  color: var(--muted-foreground);
}
.exptargets__tools {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.9rem 1.25rem 1.1rem;
  border-top: 1px solid var(--border);
}
.exptargets__auth {
  padding: 0.9rem 1.25rem 1.1rem;
  border-top: 1px solid var(--border);
  background: var(--page-bg-subtle);
}
.exptargets__auth-title {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--foreground);
}
.exptargets__auth-note {
  margin: 0.2rem 0 0.6rem;
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--muted-foreground);
}
.exptargets__auth-input {
  max-width: 22rem;
}
.exptargets__auth-error {
  margin: 0.45rem 0 0;
  font-size: 0.8rem;
  color: var(--destructive);
}
.exptargets__auth-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.exptarget {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 0.9rem 1.25rem;
  border-bottom: 1px solid var(--border);
  transition: background 0.2s ease;
}
.exptarget:last-child {
  border-bottom: none;
}
.exptarget:hover {
  background: var(--card-hover);
}
.exptarget--stale {
  background: var(--warning-soft);
}
.exptarget--stale:hover {
  background: var(--warning-soft);
}
.exptarget--stale .exptarget__note {
  color: var(--warning);
}
.exptarget--unusable {
  background: var(--muted);
}
.exptarget--unusable:hover {
  background: var(--muted);
}
.exptarget--unusable .exptarget__name {
  color: var(--muted-foreground);
}
.exptarget__mono {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: var(--radius-full);
  background: var(--exptarget-accent);
  color: var(--primary-foreground);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.exptarget__body {
  flex: 1 1 auto;
  min-width: 0;
}
.exptarget__name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--foreground);
}
.exptarget__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem 0.6rem;
  margin-top: 0.25rem;
  font-size: 0.78rem;
  color: var(--muted-foreground);
}
.exptarget__note {
  margin: 0.45rem 0 0;
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--muted-foreground);
}
.exptarget__actions {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}
.exptarget__id {
  -webkit-user-select: all;
          user-select: all;
  max-width: 14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.1rem 0.35rem;
  border-radius: var(--radius-sm);
  background: var(--secondary);
  color: var(--secondary-foreground);
  font-family: var(--font-mono);
  font-size: 0.72rem;
}
@media (max-width: 767px) {
  .exptarget {
    flex-wrap: wrap;
  }
  .exptarget__actions {
    width: 100%;
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/management/modelManagement/styles/model-training-result.scss"],"names":[],"mappings":"AAiBA;EACE,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAbM;EAcN,gBAAA;EACA,sBAAA;AAhBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAzBW;EA0BX,4BAvBU;EAwBV,4BA1Be;EA2Bf,+BAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,8BAtCY;EAuCZ,eAAA;EACA,2BAAA;AAjBJ;AAkBI;EAAU,qBA9CD;AA+Bb;AAgBI;EAAkB,iCAAA;EAAgC,mBAAA;AAZtD;AAeE;EAAS,8BA7CK;EA6CkB,gBAAA;AAXlC;AAaE;EACE,gBAAA;EACA,kBAAA;EACA,wBAnDM;EAoDN,uBAAA;AAXJ;AAcE;EACE,iBAAA;EACA,8BAxDY;AA4ChB;AAeE;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AAbJ;AAcI;EAAU,4BAAA;EAA8B,kBAAA;AAV5C;AAWI;EAAY,+BAAA;EAAiC,qBAAA;AAPjD;AAQI;EAAa,+BAAA;EAAiC,qBAAA;AAJlD;AAKI;EAAU,4BAAA;EAA8B,kBAAA;AAD5C;AAEI;EAAY,mCAAA;EAAqC,yBAAA;AAErD;AADI;EAAa,4BAAA;EAA8B,kCAAA;AAK/C;AAFE;EACE,iBAAA;EACA,aAAA;EACA,WAAA;AAIJ;;AACA;EACE,uBA/EW;EAgFX,4BA7EU;EA8EV,4BAhFe;EAiFf,+BAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;AAEF;AADE;EAAU,6BAAA;EAA+B,4BApFpB;AAyFvB;AAHE;EACE,aAAA;EACA,gCAAA;AAKJ;AAJI;EAHF;IAG8B,0BAAA;EAQ9B;AACF;AANE;EACE,eAAA;EACA,qCAAA;AAQJ;AAPI;EAHF;IAG8B,kBAAA;IAAoB,sCAAA;EAYlD;AACF;AAVE;EACE,eAAA;EACA,gFAAA;AAYJ;AATE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAhHY;EAiHZ,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAWJ;AAVI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,0BAlHM;EAmHN,kBAAA;AAYN;AARE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AAUJ;AAPE;EACE,gBAAA;AASJ;AANE;EACE,cAAA;EACA,kBAAA;EACA,8BA3Ia;EA4Ib,sBAAA;EACA,yBAAA;EACA,qBAAA;AAQJ;AALE;EACE,kBAAA;EACA,gBAAA;EACA,wBAtJM;AA6JV;AAJE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;AAMJ;AALI;EAJF;IAI8B,qCAAA;EAS9B;AACF;AATI;EALF;IAK8B,0BAAA;EAa9B;AACF;;AATA;EACE,uBAhKW;EAiKX,+BA7Ja;EA8Jb,+BAAA;EACA,4BAlKe;EAmKf,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qDAAA;AAYF;AAXE;EACE,6BAAA;EACA,4BAxKmB;EAyKnB,2BAAA;AAaJ;AAVE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAYJ;AATE;EACE,kBAAA;EACA,oBAAA;AAWJ;AARE;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8BAhMY;EAiMZ,yBAAA;AAUJ;AAPE;EAAU,gBAAA;AAUZ;AARE;EACE,iBAAA;EACA,gBAAA;EACA,wBA1MM;EA2MN,uBAAA;EACA,gBAAA;AAUJ;AAPE;EACE,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AASJ;AANE;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;AAQJ;;AAHA;EACE,sBAAA;AAMF;AAJE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;EACA,oBAAA;AAMJ;AALI;EALF;IAK8B,0BAAA;EAS9B;AACF;;AANA;EACE,uBAxOW;EAyOX,4BAtOU;EAuOV,4BAzOe;EA0Of,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;AASF;AARE;EAAU,6BAAA;EAA+B,4BA9OpB;AA0PvB;AAVE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBA7PM;EA8PN,sCAAA;EACA,qBAAA;EACA,kBAAA;AAYJ;AAXI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,0BAhQM;EAiQN,kBAAA;AAaN;AATE;EACE,kBAAA;EACA,8BA/QY;EAgRZ,gBAAA;AAWJ;AARE;EACE,qBAAA;EACA,aAAA;EACA,iBAAA;AAUJ;AAPE;EACE,kBAAA;EACA,8BA3RY;EA4RZ,aAAA;EACA,kBAAA;EACA,gBAAA;AASJ;;AAJA;EACE,uBAjSW;EAkSX,4BA/RU;EAgSV,4BAlSe;EAmSf,+BAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;AAOF;AANE;EAAU,6BAAA;EAA+B,4BAtSpB;AAgTvB;AARE;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAlTM;EAmTN,sCAAA;EACA,kBAAA;AAUJ;AATI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,0BApTM;EAqTN,kBAAA;AAWN;AAPE;EAAU,gBAAA;AAUZ;AARE;EACE,aAAA;EACA,uCAAA;EACA,YAAA;EACA,oBAAA;AAUJ;AATI;EALF;IAK8B,0BAAA;EAa9B;AACF;AAXE;EACE,iBAAA;EACA,gCAAA;EACA,+BAvUW;EAwUX,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,8BApVY;EAqVZ,wDAAA;AAaJ;AAZI;EACE,4BA5VO;EA6VP,+BAAA;EACA,qBA9VO;AA4Wb;AAZI;EACE,iCAAA;EACA,mBAAA;AAcN;AAVE;EAAiB,eAAA;EAAiB,gBAAA;AAcpC;AAbE;EAAiB,kBAAA;EAAoB,mBAAA;EAAqB,8BAjW3C;AAmXjB;AAhBE;EAAY,gBAAA;AAmBd;AAlBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BA3WY;AA+XhB;AAjBE;EACE,iBAAA;EACA,+BAAA;EACA,+BA1WW;EA2WX,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;AAmBJ;AAlBI;EAAM,iBAAA;EAAmB,WAAA;EAAa,mBAAA;AAuB1C;AApBE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BA9XY;AAoZhB;AArBI;EAAO,cAAA;EAAgB,kBAAA;EAAoB,iBAAA;EAAmB,8BA9XjD;AAyZjB;AAxBE;EACE,iBAAA;EACA,+BAAA;EACA,+BA9XW;EA+XX,eAAA;EACA,wBAAA;AA0BJ;AAvBE;EACE,kBAAA;EACA,gBAAA;EACA,8BA7YY;EA8YZ,qBAAA;EACA,yBAAA;EACA,qBAAA;AAyBJ;AAtBE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;AAwBJ;AAvBI;EAAK,qBAAA;AA0BT;AAvBE;EAAmB,aAAA;AA0BrB;AAxBE;EACE,iBAAA;EACA,8BA9Za;EA+Zb,gBAAA;AA0BJ;;AArBA;EACE,sBAAA;AAwBF;AAtBE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;EACA,oBAAA;AAwBJ;AAvBI;EALF;IAK8B,0BAAA;EA2B9B;AACF;AAzBE;EACE,uBA9aS;EA+aT,4BA5aQ;EA6aR,4BA/aa;EAgbb,+BAAA;EACA,gBAAA;EACA,gCAAA;AA2BJ;AA1BI;EAAU,6BAAA;EAA+B,4BAlbtB;AAgdvB;AA3BE;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,wBA/bM;EAgcN,sCAAA;EACA,kBAAA;AA6BJ;AA5BI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,0BAjcM;EAkcN,kBAAA;AA8BN;AA1BE;EAAe,gBAAA;AA6BjB;AAzBE;EAAU,mBAAA;AA4BZ;AA1BE;EACE,kBAAA;EACA,gBAAA;EACA,8BAvdY;EAwdZ,qBAAA;AA4BJ;AAzBE;EACE,cAAA;EACA,wBAAA;EACA,wBAAA;EACA,+BAxdW;EAydX,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;AA2BJ;AAxBE;EACE,iCAAA;EACA,wBAAA;EACA,aAAA;EACA,+BApeW;EAqeX,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AA0BJ;AAvBE;EACE,kBAAA;EACA,8BApfa;EAqfb,kBAAA;AAyBJ;;AApBA;EACE,uBAzfW;EA0fX,4BAvfU;EAwfV,4BA1fe;EA2ff,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;AAuBF;AAtBE;EAAU,6BAAA;EAA+B,4BA9fpB;AAwhBvB;AAxBE;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,wBA1gBM;EA2gBN,sCAAA;EACA,kBAAA;AA0BJ;AAzBI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,0BA5gBM;EA6gBN,kBAAA;AA2BN;AAvBE;EAAU,gBAAA;AA0BZ;AAxBE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AA0BJ;AAzBI;EAJF;IAI8B,0BAAA;EA6B9B;AACF;AA3BE;EACE,aAAA;EACA,+BAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;AA6BJ;AA5BI;EACE,8BAziBU;EA0iBV,gBAAA;EACA,iBAAA;AA8BN;AA5BI;EAAK,gBAAA;EAAkB,SAAA;EAAW,wBA9iB5B;AA+kBV;AA9BE;EACE,+BAAA;EACA,+BA3iBW;EA4iBX,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,6BAAA;AAgCJ;;AApBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAuBJ;AApBE;EACE,kBAAA;EACA,8BA7kBY;EA8kBZ,gBAAA;EACA,mBAAA;AAsBJ;AAnBE;EACE,wBAAA;EACA,mBAAA;EACA,+BA9kBW;EA+kBX,oCAAA;EACA,mCAAA;EACA,wBAAA;EACA,kBAAA;EAGA,sBAAA;AAmBJ;AAhBE;EACE,aAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAkBJ;AAhBI;EACE,8BAvmBU;EAwmBV,gBAAA;AAkBN;AAfI;EACE,SAAA;EACA,wBA9mBI;EA+mBJ,YAAA;AAiBN;AAbE;EACE,cAAA;EAGA,wBAAA;UAAA,gBAAA;EACA,uBAAA;EACA,+BAjnBW;EAknBX,wBAAA;EACA,+BAAA;EACA,6BAAA;EACA,kBAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAYJ;AATE;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAWJ;AARE;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAUJ;AAPE;EAAU,mBAAA;AAUZ;;AACA;EACE,uBAxpBW;EAypBX,+BAAA;EACA,4BAvpBU;EAwpBV,4BAAA;EACA,gBAAA;AAEF;AAAE;EACE,uBAAA;EACA,sCAAA;AAEJ;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,wBA3qBM;AA4qBV;AAEE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAjrBY;AAirBhB;AAGE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AADJ;AAIE;EACE,eAAA;EACA,oBAAA;EACA,iCAAA;EACA,+BAvrBW;EAwrBX,kBAAA;EACA,iBAAA;EACA,8BAjsBY;AA+rBhB;AAII;EAAI,mBAAA;AADR;AAC6B;EAAe,gBAAA;AAE5C;AACE;EACE,gBAAA;EACA,wBAzsBM;AA0sBV;AAEE;EACE,8BA3sBa;AA2sBjB;AAGE;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;EACA,mCAAA;AADJ;AAKE;EACE,8BAAA;EACA,mCAAA;EACA,iCAAA;AAHJ;AAME;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAnuBM;AA+tBV;AAOE;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAzuBY;AAouBhB;AAUE;EACE,gBAAA;AARJ;AAWE;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AATJ;AAYE;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAVJ;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,sCAAA;EACA,gCAAA;AAXF;AAYE;EAAe,mBAAA;AATjB;AAUE;EAAU,6BAAA;AAPZ;AAWE;EACE,+BAAA;AATJ;AAUI;EAAU,+BAAA;AAPd;AAQI;EAAmB,qBAAA;AALvB;AAUE;EACE,wBAAA;AARJ;AASI;EAAU,wBAAA;AANd;AAOI;EAAmB,8BAvxBP;AAmxBhB;AAOE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;EACA,mCAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AALJ;AAQE;EACE,cAAA;EACA,YAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAtzBM;AA+yBV;AAUE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BA/zBY;AAuzBhB;AAWE;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAt0BY;AA6zBhB;AAYE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AAVJ;AAaE;EAGE,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAn1BW;EAo1BX,4BAAA;EACA,kCAAA;EACA,6BAAA;EACA,kBAAA;AAbJ;AAgBE;EAjGF;IAkGI,eAAA;EAbF;EAcE;IACE,WAAA;IACA,2BAAA;EAZJ;AACF","sourcesContent":["// Model Training Result – Professional Dashboard Design System\n$tr-primary: var(--primary);\n$tr-primary-hover: var(--primary-hover);\n$tr-border: var(--border);\n$tr-border-light: var(--border);\n$tr-text: var(--foreground);\n$tr-text-muted: var(--muted-foreground);\n$tr-text-subtle: var(--muted-foreground);\n$tr-bg: var(--page-bg);\n$tr-card-bg: var(--card);\n$tr-card-shadow: var(--shadow-sm);\n$tr-card-shadow-hover: var(--shadow-md);\n$tr-radius: var(--radius);\n$tr-radius-sm: var(--radius-sm);\n$tr-accent: var(--primary);\n$tr-transition: 0.2s ease;\n\n.training-result-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem 0 2rem;\n  background: $tr-bg;\n  min-height: auto;\n  box-sizing: border-box;\n}\n\n// Header – compact, professional\n.training-result-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1.25rem;\n  background: $tr-card-bg;\n  border-radius: $tr-radius;\n  box-shadow: $tr-card-shadow;\n  border: 1px solid $tr-border;\n\n  &__back {\n    background: none;\n    border: none;\n    padding: 0;\n    font-size: 0.9rem;\n    color: $tr-text-muted;\n    cursor: pointer;\n    transition: color $tr-transition;\n    &:hover { color: $tr-primary; }\n    &:focus-visible { outline: 2px solid $tr-primary; outline-offset: 2px; }\n  }\n\n  &__sep { color: $tr-text-muted; font-weight: 300; }\n\n  &__title {\n    font-weight: 600;\n    font-size: 1.15rem;\n    color: $tr-text;\n    letter-spacing: -0.01em;\n  }\n\n  &__version {\n    font-size: 0.9rem;\n    color: $tr-text-muted;\n  }\n\n  &__badge {\n    font-size: 0.7rem;\n    font-weight: 600;\n    padding: 0.25rem 0.6rem;\n    border-radius: 4px;\n    letter-spacing: 0.5px;\n    &--type { background: var(--info-soft); color: var(--info); }\n    &--status { background: var(--primary-soft); color: var(--success); }\n    &--success { background: var(--primary-soft); color: var(--success); }\n    &--info { background: var(--info-soft); color: var(--info); }\n    &--danger { background: var(--destructive-soft); color: var(--destructive); }\n    &--default { background: var(--secondary); color: var(--secondary-foreground); }\n  }\n\n  &__actions {\n    margin-left: auto;\n    display: flex;\n    gap: 0.5rem;\n  }\n}\n\n// Overview strip – Dataset & Performance\n.overview-strip {\n  background: $tr-card-bg;\n  border-radius: $tr-radius;\n  box-shadow: $tr-card-shadow;\n  border: 1px solid $tr-border;\n  margin-bottom: 1.25rem;\n  overflow: hidden;\n  transition: box-shadow $tr-transition;\n  &:hover { background: var(--card-hover); box-shadow: $tr-card-shadow-hover; }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1fr 1.4fr;\n    @media (max-width: 991px) { grid-template-columns: 1fr; }\n  }\n\n  &__info {\n    padding: 1.5rem;\n    border-right: 1px solid $tr-border;\n    @media (max-width: 991px) { border-right: none; border-bottom: 1px solid $tr-border; }\n  }\n\n  &__metrics {\n    padding: 1.5rem;\n    background: linear-gradient(135deg, var(--page-bg-subtle) 0%, var(--muted) 100%);\n  }\n\n  &__section-title {\n    font-size: 0.7rem;\n    font-weight: 600;\n    letter-spacing: 1px;\n    color: $tr-text-muted;\n    text-transform: uppercase;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    &::before {\n      content: \"\";\n      width: 3px;\n      height: 1rem;\n      background: $tr-accent;\n      border-radius: 2px;\n    }\n  }\n\n  &__info-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem 1.75rem;\n  }\n\n  &__info-item {\n    min-width: 120px;\n  }\n\n  &__info-label {\n    display: block;\n    font-size: 0.75rem;\n    color: $tr-text-subtle;\n    margin-bottom: 0.25rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  &__info-value {\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: $tr-text;\n  }\n\n  &__metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0.75rem;\n    @media (max-width: 991px) { grid-template-columns: repeat(2, 1fr); }\n    @media (max-width: 480px) { grid-template-columns: 1fr; }\n  }\n}\n\n// Metric card – accent header, progress bar\n.metric-card {\n  background: $tr-card-bg;\n  border-radius: $tr-radius-sm;\n  border: 1px solid $tr-border;\n  box-shadow: $tr-card-shadow;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow $tr-transition, transform $tr-transition;\n  &:hover {\n    background: var(--card-hover);\n    box-shadow: $tr-card-shadow-hover;\n    transform: translateY(-1px);\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    padding: 0.6rem 0.85rem;\n  }\n\n  &__icon {\n    font-size: 0.85rem;\n    margin-right: 0.5rem;\n  }\n\n  &__label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    color: $tr-text-muted;\n    text-transform: uppercase;\n  }\n\n  &__body { padding: 0.85rem; }\n\n  &__value {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: $tr-text;\n    letter-spacing: -0.03em;\n    line-height: 1.2;\n  }\n\n  &__progress {\n    height: 4px;\n    background: var(--muted);\n    border-radius: 2px;\n    margin-top: 0.6rem;\n    overflow: hidden;\n  }\n\n  &__progress-bar {\n    height: 100%;\n    border-radius: 2px;\n    transition: width 0.4s ease;\n  }\n}\n\n// Training charts\n.training-charts {\n  margin-bottom: 1.25rem;\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n    align-items: stretch;\n    @media (max-width: 767px) { grid-template-columns: 1fr; }\n  }\n}\n\n.training-chart-card {\n  background: $tr-card-bg;\n  border-radius: $tr-radius;\n  box-shadow: $tr-card-shadow;\n  border: 1px solid $tr-border;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow $tr-transition;\n  &:hover { background: var(--card-hover); box-shadow: $tr-card-shadow-hover; }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.9rem 1.1rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: $tr-text;\n    border-bottom: 1px solid $tr-border-light;\n    padding-left: 1.25rem;\n    position: relative;\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 3px;\n      height: 1.25rem;\n      background: $tr-accent;\n      border-radius: 2px;\n    }\n  }\n\n  &__loading {\n    font-size: 0.85rem;\n    color: $tr-text-muted;\n    font-weight: 400;\n  }\n\n  &__body {\n    padding: 0.75rem 1rem;\n    height: 300px;\n    min-height: 300px;\n  }\n\n  &__empty {\n    text-align: center;\n    color: $tr-text-muted;\n    padding: 2rem;\n    font-size: 0.95rem;\n    line-height: 1.5;\n  }\n}\n\n// Inference playground\n.inference-playground {\n  background: $tr-card-bg;\n  border-radius: $tr-radius;\n  box-shadow: $tr-card-shadow;\n  border: 1px solid $tr-border;\n  margin-bottom: 1.25rem;\n  overflow: hidden;\n  transition: box-shadow $tr-transition;\n  &:hover { background: var(--card-hover); box-shadow: $tr-card-shadow-hover; }\n\n  &__header {\n    padding: 0.9rem 1.1rem 0.9rem 1.25rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: $tr-text;\n    border-bottom: 1px solid $tr-border;\n    position: relative;\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 3px;\n      height: 1.25rem;\n      background: $tr-accent;\n      border-radius: 2px;\n    }\n  }\n\n  &__body { padding: 1.25rem; }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1fr 1.2fr 0.85fr;\n    gap: 1.25rem;\n    align-items: stretch;\n    @media (max-width: 991px) { grid-template-columns: 1fr; }\n  }\n\n  &__upload-zone {\n    min-height: 200px;\n    border: 2px dashed $tr-border;\n    border-radius: $tr-radius-sm;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: $tr-text-muted;\n    transition: border-color $tr-transition, background $tr-transition;\n    &:hover {\n      border-color: $tr-primary;\n      background: var(--primary-soft);\n      color: $tr-primary;\n    }\n    &:focus-visible {\n      outline: 2px solid $tr-primary;\n      outline-offset: 2px;\n    }\n  }\n\n  &__upload-text { font-size: 1rem; font-weight: 500; }\n  &__upload-hint { font-size: 0.85rem; margin-top: 0.35rem; color: $tr-text-subtle; }\n\n  &__slider { margin-top: 1rem; }\n  &__slider-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.35rem;\n    font-size: 0.9rem;\n    color: $tr-text-muted;\n  }\n\n  &__preview {\n    min-height: 220px;\n    border: 1px solid $tr-border;\n    border-radius: $tr-radius-sm;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    background: var(--muted);\n    img { max-height: 300px; width: 100%; object-fit: contain; }\n  }\n\n  &__preview-placeholder {\n    text-align: center;\n    padding: 1.5rem;\n    font-size: 0.95rem;\n    color: $tr-text-muted;\n    span { display: block; margin-top: 0.5rem; font-size: 0.9rem; color: $tr-text-subtle; }\n  }\n\n  &__classes {\n    min-height: 220px;\n    border: 1px solid $tr-border;\n    border-radius: $tr-radius-sm;\n    padding: 0.9rem;\n    background: var(--muted);\n  }\n\n  &__classes-title {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: $tr-text-muted;\n    margin-bottom: 0.6rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  &__classes-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    font-size: 0.9rem;\n    li { margin-bottom: 0.6rem; }\n  }\n\n  &__class--dimmed { opacity: 0.45; }\n\n  &__classes-empty {\n    font-size: 0.9rem;\n    color: $tr-text-subtle;\n    line-height: 1.5;\n  }\n}\n\n// Export section\n.export-section {\n  margin-bottom: 1.25rem;\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n    align-items: stretch;\n    @media (max-width: 767px) { grid-template-columns: 1fr; }\n  }\n\n  &__card {\n    background: $tr-card-bg;\n    border-radius: $tr-radius;\n    box-shadow: $tr-card-shadow;\n    border: 1px solid $tr-border;\n    overflow: hidden;\n    transition: box-shadow $tr-transition;\n    &:hover { background: var(--card-hover); box-shadow: $tr-card-shadow-hover; }\n  }\n\n  &__card-header {\n    padding: 0.9rem 1.1rem 0.9rem 1.25rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: $tr-text;\n    border-bottom: 1px solid $tr-border;\n    position: relative;\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 3px;\n      height: 1.25rem;\n      background: $tr-accent;\n      border-radius: 2px;\n    }\n  }\n\n  &__card-body { padding: 1.25rem; }\n\n  // A full-width row under the 2-column grid, for a card that is an action rather\n  // than a reference panel.\n  &__wide { margin-top: 1.25rem; }\n\n  &__label {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: $tr-text-muted;\n    margin-bottom: 0.5rem;\n  }\n\n  &__code {\n    display: block;\n    padding: 0.65rem 0.85rem;\n    background: var(--muted);\n    border-radius: $tr-radius-sm;\n    font-size: 0.85rem;\n    word-break: break-all;\n    margin-bottom: 1rem;\n    border: 1px solid $tr-border;\n    font-family: var(--font-mono);\n  }\n\n  &__pre {\n    background: var(--page-bg-subtle);\n    color: var(--foreground);\n    padding: 1rem;\n    border-radius: $tr-radius-sm;\n    font-size: 0.8rem;\n    margin: 0;\n    overflow-x: auto;\n    font-family: var(--font-mono);\n    line-height: 1.5;\n  }\n\n  &__hint {\n    font-size: 0.85rem;\n    color: $tr-text-subtle;\n    margin-top: 0.5rem;\n  }\n}\n\n// Training metadata\n.training-metadata {\n  background: $tr-card-bg;\n  border-radius: $tr-radius;\n  box-shadow: $tr-card-shadow;\n  border: 1px solid $tr-border;\n  margin-bottom: 1.5rem;\n  overflow: hidden;\n  transition: box-shadow $tr-transition;\n  &:hover { background: var(--card-hover); box-shadow: $tr-card-shadow-hover; }\n\n  &__header {\n    padding: 0.9rem 1.1rem 0.9rem 1.25rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: $tr-text;\n    border-bottom: 1px solid $tr-border;\n    position: relative;\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 3px;\n      height: 1.25rem;\n      background: $tr-accent;\n      border-radius: 2px;\n    }\n  }\n\n  &__body { padding: 1.25rem; }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.5rem;\n    @media (max-width: 767px) { grid-template-columns: 1fr; }\n  }\n\n  &__dl {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    gap: 0.35rem 1.25rem;\n    margin: 0;\n    font-size: 0.95rem;\n    dt {\n      color: $tr-text-muted;\n      font-weight: 500;\n      font-size: 0.9rem;\n    }\n    dd { font-weight: 500; margin: 0; color: $tr-text; }\n  }\n\n  &__logs {\n    border: 1px solid $tr-border;\n    border-radius: $tr-radius-sm;\n    padding: 0.9rem;\n    max-height: 200px;\n    overflow-y: auto;\n    font-size: 0.9rem;\n    background: var(--muted);\n    font-family: var(--font-mono);\n  }\n}\n\n// ── Deployment pack card ───────────────────────────────────────────────────────\n// The pack names no provider (see DeploymentPackCard.jsx): it is one immutable\n// artifact, and WHERE it may go is the .exptarget list below.\n// Sits inside .export-section__grid as a third card, so it inherits the card frame,\n// header rule and body padding from .export-section__card. Only what is genuinely\n// new to this card lives here. Every colour is a token: this page is checked in\n// both themes (DESIGN_GUIDE.md), and a literal is a hole the theme cannot reach.\n.deploypack {\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n  }\n\n  &__note {\n    font-size: 0.85rem;\n    color: $tr-text-muted;\n    line-height: 1.5;\n    margin-bottom: 1rem;\n  }\n\n  &__alert {\n    padding: 0.65rem 0.85rem;\n    margin-bottom: 1rem;\n    border-radius: $tr-radius-sm;\n    border: 1px solid var(--destructive);\n    background: var(--destructive-soft);\n    color: var(--foreground);\n    font-size: 0.85rem;\n    // A build failure carries the toolchain's own words, which can be long and\n    // have no spaces. Without this the card grows a horizontal scrollbar.\n    word-break: break-word;\n  }\n\n  &__facts {\n    display: grid;\n    grid-template-columns: minmax(6.5rem, auto) 1fr;\n    gap: 0.4rem 0.9rem;\n    margin: 0 0 1rem;\n    font-size: 0.85rem;\n\n    dt {\n      color: $tr-text-muted;\n      font-weight: 500;\n    }\n\n    dd {\n      margin: 0;\n      color: $tr-text;\n      min-width: 0;   // lets the token below actually clip instead of widening the grid\n    }\n  }\n\n  &__token {\n    display: block;\n    // `all` so one click takes the WHOLE value: these are strings to be compared or\n    // pasted verbatim, and a partial selection of a digest is worse than none.\n    user-select: all;\n    padding: 0.35rem 0.5rem;\n    border-radius: $tr-radius-sm;\n    background: var(--muted);\n    border: 1px solid $tr-border;\n    font-family: var(--font-mono);\n    font-size: 0.78rem;\n    // The full digest stays in the DOM; only the display is clipped.\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__classes {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n  }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  &__hint { margin-top: 0.75rem; }\n}\n\n// ── Export targets ─────────────────────────────────────────────────────────────\n// The list of places a published pack may be sent, one row per proved site.\n// APPENDED, not woven into .deploypack above: the pack is provider-agnostic and this\n// list is the provider-specific half, so the two must stay separable — a shared block\n// is how \"the pack belongs to ProWatchly\" creeps back in.\n// Every colour is a token (DESIGN_GUIDE.md); the only runtime value is\n// --exptarget-accent, which is set inline to `var(--chart-N)` from the descriptor\n// because CSS cannot index a token by number.\n.exptargets {\n  background: $tr-card-bg;\n  border: 1px solid $tr-border;\n  border-radius: $tr-radius;\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n\n  &__head {\n    padding: 0.9rem 1.25rem;\n    border-bottom: 1px solid $tr-border;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: $tr-text;\n  }\n\n  &__sub {\n    margin: 0.2rem 0 0;\n    font-size: 0.85rem;\n    line-height: 1.5;\n    color: $tr-text-muted;\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  &__empty {\n    margin: 1.25rem;\n    padding: 1rem 1.1rem;\n    background: var(--page-bg-subtle);\n    border-radius: $tr-radius-sm;\n    font-size: 0.85rem;\n    line-height: 1.55;\n    color: $tr-text-muted;\n\n    p { margin: 0 0 0.35rem; &:last-child { margin-bottom: 0; } }\n  }\n\n  &__empty-title {\n    font-weight: 600;\n    color: $tr-text;\n  }\n\n  &__empty-note {\n    color: $tr-text-subtle;\n  }\n\n  &__tools {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    padding: 0.9rem 1.25rem 1.1rem;\n    border-top: 1px solid $tr-border;\n  }\n\n  // The actor's own password, asked for where the control was pressed.\n  &__auth {\n    padding: 0.9rem 1.25rem 1.1rem;\n    border-top: 1px solid $tr-border;\n    background: var(--page-bg-subtle);\n  }\n\n  &__auth-title {\n    margin: 0;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: $tr-text;\n  }\n\n  &__auth-note {\n    margin: 0.2rem 0 0.6rem;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    color: $tr-text-muted;\n  }\n\n  // Width only. The chrome — ground, border, focus ring — comes from the global\n  // .form-control so this field cannot drift from every other input in the app.\n  &__auth-input {\n    max-width: 22rem;\n  }\n\n  &__auth-error {\n    margin: 0.45rem 0 0;\n    font-size: 0.8rem;\n    color: var(--destructive);\n  }\n\n  &__auth-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-top: 0.75rem;\n  }\n}\n\n.exptarget {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  padding: 0.9rem 1.25rem;\n  border-bottom: 1px solid $tr-border;\n  transition: background $tr-transition;\n  &:last-child { border-bottom: none; }\n  &:hover { background: var(--card-hover); }\n\n  // Stale = the link was proved once and has not been re-checked lately. It is still\n  // shown, because hiding it would read as the site having been taken away.\n  &--stale {\n    background: var(--warning-soft);\n    &:hover { background: var(--warning-soft); }\n    .exptarget__note { color: var(--warning); }\n  }\n\n  // Past the re-check ceiling, or a task this target's runtime cannot run: the row\n  // stays (the site is still yours) and only the action goes.\n  &--unusable {\n    background: var(--muted);\n    &:hover { background: var(--muted); }\n    .exptarget__name { color: $tr-text-muted; }\n  }\n\n  &__mono {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 2.25rem;\n    height: 2.25rem;\n    border-radius: var(--radius-full);\n    background: var(--exptarget-accent);\n    color: var(--primary-foreground);\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n  }\n\n  &__body {\n    flex: 1 1 auto;\n    min-width: 0;   // lets the id chip below ellipsise instead of widening the row\n  }\n\n  &__name {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.45rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: $tr-text;\n  }\n\n  &__meta {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.25rem 0.6rem;\n    margin-top: 0.25rem;\n    font-size: 0.78rem;\n    color: $tr-text-muted;\n  }\n\n  &__note {\n    margin: 0.45rem 0 0;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    color: $tr-text-muted;\n  }\n\n  &__actions {\n    flex: 0 0 auto;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 0.5rem;\n  }\n\n  &__id {\n    // `all` so one click takes the whole id: it is read out to a Gemmiz administrator\n    // or pasted into the portal, and half of an ObjectId is worse than none.\n    user-select: all;\n    max-width: 14rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding: 0.1rem 0.35rem;\n    border-radius: $tr-radius-sm;\n    background: var(--secondary);\n    color: var(--secondary-foreground);\n    font-family: var(--font-mono);\n    font-size: 0.72rem;\n  }\n\n  @media (max-width: 767px) {\n    flex-wrap: wrap;\n    &__actions {\n      width: 100%;\n      justify-content: flex-start;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
